import React, { useState, useEffect } from 'react';
import './Benchmarking.scss';
import MainDropDown from '../../partials/MainDropDown/MainDropDown.js';
import CheckList from '../../partials/CheckList/CheckList.js';
import Popup from '../../partials/Popup/Popup.js';
import AudioPopUp from './AudioPopup.js'
import ItemInfoPopup from './ItemInfoPopup.js';
import CapabilitiesPopUp from './CapabilitiesPopUp.js'

import TeamCheckIn from '../TeamCheckIn/TeamCheckIn.js';
import BenchmarkingQuiz from '../BenchmarkQuiz/BenchmarkQuiz.js';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

import BackButton from '../../partials/Button/BackButton';
import Scroll from '../../partials/Scroll/Scroll';

const Benchmarking = props => {
    const [pageState,setPageState] = useState('checklist');
    const [clickedCheckboxes, setClickedCheckboxes] = useState([]);
    const [correctCheckBoxes, setCorrectCheckboxes] = useState([]);
    const [storyId, setStoryId] = useState(0);
    const [storiesComplete, setStoriesComplete] = useState([])

    const [feedback,setFeedback] = useState();
    const [showFeedback,setShowFeedback] = useState(true);
    const [showAudio,setShowAudio] = useState(false)
    const [currentItemInfo, setCurrentItemInfo] = useState([-1,-1]);
    const [showCapabilities, setShowCapabilities] = useState(false)

    const storyComplete = () =>{
        if(props.onComplete)props.onComplete()
    }

    const handleCheckboxClick = (index, subI) => {
        console.log("test", index,subI)
        console.log(clickedCheckboxes)
        let newArr = [...clickedCheckboxes]
        newArr[index][subI] = !newArr[index][subI]
        setClickedCheckboxes(newArr)
    }

    const getCorrectCheck = () =>{
        let newArr = []
        props.data.story[storyId].correctCheckList.map((e) => {
            let subArr = [e.correct];
            e.sub.map((f, i) => {
                subArr.push(f.correct)
            })
            newArr.push(subArr);
        })
        setCorrectCheckboxes(newArr)
    }

    useEffect(() => {
        // getAllStories();
        let newArr = []
        props.data.capabilities.map((e) => {
            let subArr = [false];
            e.subCapabilities.map((e, i) => {
                subArr.push(false)
            })
            newArr.push(subArr);
        })
        setClickedCheckboxes(newArr)
        // console.log(newArr)
    }, [props.data.capabilities])

    useEffect(()=>{
        getCorrectCheck();
    },[props.data.story[storyId].correctCheckList])
    console.log(props)
    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
        <div className={`Benchmarking`}>
                {pageState === "checklist" &&
                <>
                    <p className="header">{props.data.instructionText.capabilities}</p>
                    <div className="left-container">
                        <div className="header-contiaiter">
                            <div className="back-btn-container back-btn" onClick={()=>props.goBackToPreviousSegment()}>
                                <BackButton className="back-button" text={"Back"}/>
                            </div>
                        </div>
                        <p className="capabilities-header">Capabilities</p>
                        <Scroll>
                        <div className="dropdown-contaier">
                            {clickedCheckboxes.length !== 0&&
                                props.data.capabilities.map((e,i) => {
                                    return <MainDropDown data={e} index={i} clickedCheckboxes={clickedCheckboxes} checked={clickedCheckboxes[i][0]} showAudio={()=>setShowAudio(!showAudio)} setCurrentItemInfo={setCurrentItemInfo} />
                                })
                            }
                        </div>
                        </Scroll>
                    </div>
                    <div className="right-container">
                        <CheckList setPageState={setPageState} pageState={pageState} handleCheckboxClick={handleCheckboxClick} correctCheckBoxes={correctCheckBoxes} clickedCheckboxes={clickedCheckboxes} checklistItems={props.data.checklistItems} capabilities={props.data.capabilities} />
                    </div>
                    {showFeedback && false &&
                        <Popup data={props.data.story[storyId].setUp} onComplete={()=>setShowFeedback(false)} centered={true}/>
                    }
                    {showAudio &&
                        <AudioPopUp onClose={()=>setShowAudio(!showAudio)} />
                    }
                    {currentItemInfo[0] > -1 &&
                        <ItemInfoPopup data={currentItemInfo[1] === -1 ? props.data.capabilities[currentItemInfo[0]] : props.data.capabilities[currentItemInfo[0]].subCapabilities[currentItemInfo[1]]} onClose={()=>setCurrentItemInfo([-1,-1])} />
                    }
                </>
                }
                {/* {pageState==="teamcheckin"&&
                    <TeamCheckIn data={props.data} backClick={()=>setPageState("checklist")} story={props.data.story[storyId]} clickedCheckboxes={clickedCheckboxes} correctCheckBoxes={correctCheckBoxes} setPageState={setPageState} showCapabilities={()=>setShowCapabilities(!showCapabilities)} />
                } */}
                {pageState === "benchmarkingquiz"&&
                    <BenchmarkingQuiz data={props.data} backClick={()=>setPageState("checklist")} storyId={storyId} storyComplete={storyComplete} clickedCheckboxes={clickedCheckboxes} correctCheckBoxes={correctCheckBoxes} showCapabilities={()=>setShowCapabilities(!showCapabilities)} />
                }
                {showCapabilities &&
                    <CapabilitiesPopUp data={props.data} clickedCheckboxes={clickedCheckboxes} checked={clickedCheckboxes} onClose={()=>setShowCapabilities(!showCapabilities)}/>
                }
        </div>
        </InteractionContainer>
    )
}

export default Benchmarking
